export default "__VITE_ASSET__CtyDHErD__"